import clsx from 'clsx';
import { type ReactNode, useMemo } from 'react';

import { DEFAULT_PRIMARY_COLOR } from '@gitbook/colors';

import { PageWallpaper } from './PageWallpaper';

function getBackgroundImage(color: string) {
    const raw = `
<svg width="1700" height="800" viewBox="0 0 1700 800" style="opacity: 0.07" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <radialGradient id="fadeGradient" cx="40%" cy="40%" r="40%">
      <stop offset="0%" stop-color="${color}" />
      <stop offset="100%" stop-color="${color}" stop-opacity="0" />
    </radialGradient>
  </defs>
  <rect width="1700" height="800" fill="url(#fadeGradient)" />
</svg>
`.trim();
    const base64 = btoa(raw);
    return `data:image/svg+xml;base64,${base64}`;
}

/**
 * Colorful wallpaper for a page with a gradient.
 */
export function PageGradientWallpaper(props: {
    gradientColor?: { light: string; dark: string };
    className?: string;
    children: ReactNode;
}) {
    const { gradientColor, children, className } = props;
    const lightBg = useMemo(
        () => getBackgroundImage(gradientColor?.light || DEFAULT_PRIMARY_COLOR),
        [gradientColor?.light]
    );
    const darkBg = useMemo(
        () => getBackgroundImage(gradientColor?.dark || DEFAULT_PRIMARY_COLOR),
        [gradientColor?.dark]
    );

    return (
        <PageWallpaper
            imageLight={lightBg}
            imageDark={darkBg}
            className={clsx('bg-[length:auto] bg-top', className)}
        >
            {children}
        </PageWallpaper>
    );
}
